import { countries as countriesList } from 'countries-list'
import { sortBy } from 'lodash'

const countries = Object.keys(countriesList).map(code => {
  const country = countriesList[code as keyof typeof countriesList]
  return {
    name: country.name, // Use native name (in the country's language)
    code,
    phone: country.phone, // Phone prefix
  }
})

export const countriesAsSelectioOptions = sortBy(
  countries.map(country => ({
    label: country.name,
    value: country.code,
  })),
  'label',
)

export const phonePrefixesAsSelectionOptions = countries
  .filter(country => country.phone) // Filter out countries without phone prefix
  .map(country => ({
    label: `${country.name} (+${country.phone})`,
    value: `+${country.phone}`,
  }))

export default countries
